export default "__VITE_ASSET__CRPB7eCA__"